import React, { Component } from 'react';
import { getInvoiceInfo } from '../../../../API/FetchCall';
import PdfContainer from './PdfContainer';
import Doc from './DocService';

class EventCompare extends Component {

  constructor(props) {
    super(props);
    console.log('this.props', this.props);
    this.state = {
      compareData: this.props.viewData.compareData,
      ratingData: this.props.viewData.ratingData,
      date: this.props.viewData.date
    };
  }
  componentDidMount() {

  }
  createPdf = (html) => Doc.createPdf(html);


  render() {
    const { compareData, ratingData } = this.state;
    console.log('this.state.compareData re', compareData)
    let dataLen = compareData.length;
    let scl = dataLen > 0 ? compareData[0].name : '';
    return (

      <React.Fragment>
       <div class="row">
            <div class="hdr-logo-pdf"><img src="/assets/bewiseLogo.png" width="100%" /></div>
        </div>
        <div className="row invoice-container compare-container">
          <div className="back-drop">
            <h2>{`Confidential - Bewise prepared for ${scl.trim()}`}</h2>
             <div id="watermark"><img src="/assets/bewiseLogo.png" width="100%" /></div>
          </div>
          <div className='row'>
            <p>Date : {this.state.date}</p>
            <table className='table table-bordered comparetable'>
              <tr>
                <th>Name</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.name}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Category</th>
                {compareData.map((item, i) => {
                  return (
                    <td>{item.category}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Mode of Payment</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.payment_name ? item.payment_name : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Food</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.food ? item.food : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Hall Capacity</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.hall_capcity ? item.hall_capcity : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Car Parking</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.car_parking_slot ? item.car_parking_slot : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Two Wheeler Parking</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.two_parking_slot ? item.two_parking_slot : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Established Year</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.est_year ? item.est_year : 'NA'}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th>Event Fee</th>
                {compareData.map((item, i) => {
                  return (
                    <React.Fragment>
                      <td>{item.event_fee == 0 || item.event_fee == 'NA' ? 'NA' : (<span>&#8377; {item.event_fee}</span>)}</td>
                    </React.Fragment>
                  )
                })}
              </tr>
              <tr>
                <th colSpan={1 + compareData.length}>Rating</th>
              </tr>
              <tr>
                <th>Covid19 responses</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.covid19}</td>
                  )
                })}
              </tr>
              <tr>
                <th>
                  Quality of service (OR)
                  Comfort with Trainer / Teacher
                </th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.qty_food}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Method of Teaching / Coaching / Counselling</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.qty_method}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Information @ Website (OR) Quality of Connectivity / Campus</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.qty_info_website}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Child Safety</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.child_safety}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Ease of Interaction</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.qty_intraction}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Puntcuality / Connectivity (OR) Puntcuality</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.ontime_punctuality}</td>
                  )
                })}
              </tr>
              <tr>
                <th>Overall Rating</th>
                {ratingData.map((item, i) => {
                  return (
                    <td>{item.overall_expirence}</td>
                  )
                })}
              </tr>
            </table>
          </div>
        </div>
        <div class="row">
            <div class="hdr-logo-pdf">© Copyright 2022 BeWise. All Rights Reserved</div>
        </div>
      </React.Fragment>

    );
  }
}

export default EventCompare;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/benchmark/events_compare.jsx